module.exports = __webpack_public_path__ + "img/SureCredsLogo.895f4153.png";